import React from "react";
import { useAuth } from "../auth/AuthContext";
import {
  createStripeCheckoutSession,
  createStripeCustomerPortalSession,
} from "../billing/billingApi";

function formatValue(value, fallback = "Unavailable") {
  const text = String(value || "").trim();

  if (!text) {
    return fallback;
  }

  return text
    .replaceAll("_", " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function UserProfilePage() {
  const startCheckout = async (plan) => {
    const result = await createStripeCheckoutSession(
      plan,
      "monthly"
    );

    if (!result?.checkout_url) {
      throw new Error("Stripe Checkout URL is unavailable.");
    }

    window.location.assign(result.checkout_url);
  };

  const openCustomerPortal = async () => {
    const result = await createStripeCustomerPortalSession();

    if (!result?.portal_url) {
      throw new Error("Stripe Customer Portal URL is unavailable.");
    }

    window.location.assign(result.portal_url);
  };
  const {
    user,
    ninaAccess,
    ninaAccessLoading,
    ninaAccessError,
  } = useAuth();

  if (!user) {
    return (
      <section className="settingsPage">
        <div className="settingsPageHeader">
          <span>ANINATRADE ACCOUNT</span>
          <h2>User Profile</h2>
          <p>Sign in to view your AninaTrade account.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="settingsPage">
      <div className="settingsPageHeader">
        <span>ANINATRADE ACCOUNT</span>
        <h2>User Profile</h2>
        <p>
          Review your account identity, role, plan, and subscription status.
        </p>
      </div>

      <div className="settingsCard">
        <div className="settingsSectionHeader">
          <div>
            <span>ACCOUNT DETAILS</span>
            <h3>Profile & Subscription</h3>
          </div>
        </div>

        <dl>
          <div>
            <dt>Email</dt>
            <dd>{user.email || "Unavailable"}</dd>
          </div>

          <div>
            <dt>Account Role</dt>
            <dd>{formatValue(user.role, "User")}</dd>
          </div>

          <div>
            <dt>Current Plan</dt>
            <dd>
              {ninaAccessLoading
                ? "Loading..."
                : formatValue(
                    ninaAccess?.subscription_plan,
                    "Free"
                  )}
            </dd>
          </div>

          <div>
            <dt>Subscription Status</dt>
            <dd>
              {ninaAccessLoading
                ? "Loading..."
                : formatValue(
                    ninaAccess?.subscription_status,
                    "Unavailable"
                  )}
            </dd>
          </div>

          <div>
            <dt>Complimentary Full Access</dt>
            <dd>
              {ninaAccessLoading
                ? "Loading..."
                : ninaAccess?.complimentary_full_access
                  ? "Active"
                  : "No"}
            </dd>
          </div>
        </dl>

        {ninaAccessError && (
          <p role="alert">
            Account subscription information is temporarily unavailable.
          </p>
        )}

        <div>
          {!(
  ninaAccess?.subscription_plan !== "free" &&
  ["active", "trialing"].includes(
    ninaAccess?.subscription_status
  )
) ? (
            <button
              type="button"
              onClick={() => startCheckout("nina_plus")}
            >
              Choose AninaTrade Plus
            </button>
          ) : (
            <button
              type="button"
              onClick={openCustomerPortal}
            >
              Manage Subscription
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default UserProfilePage;
